import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchPatientList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/users", baseUrl);

  if (params.name) {
    endpointUrl.searchParams.append("name", params.name);
  }

  if (params.address) {
    endpointUrl.searchParams.append("address", params.address);
  }

  if (params.phone) {
    endpointUrl.searchParams.append("phone", params.phone);
  }

  if (params.email) {
    endpointUrl.searchParams.append("email", params.email);
  }

  if (params.orderBy) {
    endpointUrl.searchParams.append("orderBy", params.orderBy);
  }

  if (params.hospitalId) {
    endpointUrl.searchParams.append("hospitalId", params.hospitalId);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function usePatientList(params = {}) {
  return usePaginationQuery(
    [
      "patients",
      params.name,
      params.address,
      params.phone,
      params.email,
      params.orderBy,
      params.hospitalId,
    ],
    (paginationState) => fetchPatientList({ ...params, ...paginationState })
  );
}

export function useUpdatePatient(id) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/users/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res !== undefined) {
          await queryClient.invalidateQueries(["patient-detail"]);
          setTimeout(() => {
            navigate(`/patient/${id}`);
          }, 1500);
        }
      },
      onError: () => {
        console.error("Something when wrong");
      },
    }
  );
}

export async function fetchPatientDownload(params = {}) {
  const { data } = await http(`/admin/users-download`, {
    responseType: "blob",
    params: {
      ...(params.name ? { name: params.name } : {}),
      ...(params.phone ? { phone: params.phone } : {}),
      ...(params.address ? { address: params.address } : {}),
      ...(params.hospitalId ? { hospitalId: params.hospitalId } : {}),
      ...(params.orderBy ? { orderBy: params.orderBy } : {}),
    },
  });

  return data;
}

export function useHospitalDownload() {
  const { data, ...raResult } = useQuery(["patient-download"], () =>
    fetchPatientDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
